import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_get_inventory_adjustmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { project_lookups: string[], integration_id: string, transaction_type: string, transaction_id?: string, days?: number, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean }, operation_codes?: string[], in_transmission_type?: string, out_transmission_type?: string, project_ids?: number[], include_move_tasks?: boolean, take?: number }): Promise<{ adjsutments?: { transaction_id?: string, DatexAdjustmentInfo?: $frontendTypes.FootprintEdi.DatexAdjustmentInfo }[], messages?: any[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_lookups)) {
      $missingRequiredInParams.push('\'project_lookups\'');
    }
    if (isNil($inParams.integration_id)) {
      $missingRequiredInParams.push('\'integration_id\'');
    }
    if (isNil($inParams.transaction_type)) {
      $missingRequiredInParams.push('\'transaction_type\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

